/*
 * Copyright (c) 2021 Daimler AG. All rights reserved.
 * Implemented 2021 by DCCS GmbH.
 */

import { AlertColor } from '@mui/material/Alert/Alert';
import { enqueueSnackbar } from 'notistack';

export interface NotificationHandler {
  publish: (content: string | HTMLElement, severity: AlertColor) => void;
}

/**
 * Notification widget implementation.
 */
export class PushNotification implements NotificationHandler {
  /**
   * Shows the notification on the corresponding channel.
   * @param content Content to be shown (plain text or html)
   * @param severity Notification severity to be shown in
   */
  public publish(content: string | HTMLElement, severity: AlertColor) {
    // @ts-ignore
    enqueueSnackbar(content, { variant: severity ? severity.toLowerCase() : undefined });
  }
}

export let pushNotificationHandler: NotificationHandler = new PushNotification();
